import Store from 'store/store';

Store.on('QUIZ_SCROLL_ANIM_READY', (data) => {
	Store.get().admissionsQuiz.set({
		[`scrollAnim${data}Ready`]: true
	});
});

Store.on('QUIZ_FLASH_READY', () => {
	Store.get().admissionsQuiz.set({
		flashReady: true
	});
});

Store.on('QUIZ_TOGGLE_SOUND', (bool) => {
	Store.get().admissionsQuiz.set({
		soundOn: bool
	});
});